'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CloseButton = {};

exports.__exports = CloseButton;
